import service from "../service";

export default {
    // 登录
    PostLogin(data: { name: string; pass: string }): Promise<unknown> {
        return service({
            method: "POST",
            url: "/Login/Login",
            data,
        });
    },

    // 修改密码
    ChangePassword(data: { name: string; pass: string; oldpass: string }): Promise<unknown> {
        const config: any = {
            method: "POST",
            url: "/Login/ChangePassword",
            data,
            suppressBusinessErrorMessage: true,
        };
        return service(config);
    },
    
    // 
    GetInfoByToken(params: Record<string, unknown>, config: Record<string, any> = {}): Promise<unknown> {
        return service({
            ...config,
            method: "GET",
            url: "/User/GetInfoByToken",
            params: {
                ...(params || {}),
                _t: Date.now(),
            },
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                ...(config.headers || {}),
            },
        });
    },
    // 获取用户权限
    GetUserPermission(params: any, config: any = {}): Promise<any> {
        return service({
            method: "GET",
            url: "/permission/getnavigationbar",
            params: {
                ...(params || {}),
                _t: Date.now(),
            },
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                ...(config.headers || {}),
            },
            ...config,
        });
    },
    // 设备读数识别图片
    GetDeviceReadingImage(data: FormData): Promise<any> {
        return service({
            method: "POST",
            url: "/视觉大模型/设备读数识别图片",
            data,
        });
    },
     // 设备读数识别base64
     GetDeviceReadingBase64(data: any): Promise<any> {
        return service({
            method: "POST",
            url: "/视觉大模型/设备读数识别base64",
            data,
        });
    }
}
